module.exports = {
    'dictionary': {
        'keys': {
            'й': 'q',
            'ц': 'w',
            'у': 'e',
            'к': 'r',
            'е': 't',
            'н': 'y',
            'г': 'u',
            'ш': 'i',
            'щ': 'o',
            'з': 'p',
            'х': '[',
            'ъ': ']',
            'ф': 'a',
            'ы': 's',
            'в': 'd',
            'а': 'f',
            'п': 'g',
            'р': 'h',
            'о': 'j',
            'л': 'k',
            'д': 'l',
            'ж': ';',
            'э': '\'',
            'я': 'z',
            'Ч': 'X',
            'с': 'c',
            'м': 'v',
            'и': 'b',
            'т': 'n',
            'ь': 'm',
            'б': ',',
            'ю': '.',
            'Й': 'Q',
            'Ц': 'W',
            'У': 'E',
            'К': 'R',
            'Е': 'T',
            'Н': 'Y',
            'Г': 'U',
            'Ш': 'I',
            'Щ': 'O',
            'З': 'P',
            'Х': '[',
            'Ъ': ']',
            'Ф': 'A',
            'Ы': 'S',
            'В': 'D',
            'А': 'F',
            'П': 'G',
            'Р': 'H',
            'О': 'J',
            'Л': 'K',
            'Д': 'L',
            'Ж': ';',
            'Э': '\'',
            '?': 'Z',
            'ч': 'x',
            'С': 'C',
            'М': 'V',
            'И': 'B',
            'Т': 'N',
            'Ь': 'M',
            'Б': ',',
            'Ю': '.',
            'ё': '`'
        },
        'translit': {
            'а': 'a',
            'б': 'b',
            'в': 'v',
            'г': 'g',
            'д': 'd',
            'ё': 'e',
            'е': 'e',
            'ж': 'zh',
            'з': 'z',
            'и': 'i',
            'й': 'y',
            'к': 'k',
            'л': 'l',
            'м': 'm',
            'н': 'n',
            'о': 'o',
            'п': 'p',
            'р': 'r',
            'с': 's',
            'т': 't',
            'у': 'u',
            'ф': 'f',
            'х': 'h',
            'ц': 'c',
            'ч': 'ch',
            'ш': 'sh',
            'щ': 'sch',
            'ь': '\'',
            'ы': 'i\'',
            'ъ': '',
            'э': 'e\'',
            'ю': 'yu',
            'я': 'ya',
            'А': 'A',
            'Б': 'B',
            'В': 'V',
            'Г': 'G',
            'Д': 'D',
            'Е': 'E',
            'Ё': 'E',
            'Ж': 'Zh',
            'З': 'Z',
            'И': 'I',
            'Й': 'Y',
            'К': 'K',
            'Л': 'L',
            'М': 'M',
            'Н': 'N',
            'О': 'O',
            'П': 'P',
            'Р': 'R',
            'С': 'S',
            'Т': 'T',
            'У': 'U',
            'Ф': 'F',
            'Х': 'H',
            'Ц': 'C',
            'Ч': 'Ch',
            'Ш': 'Sh',
            'Щ': 'Sch',
            'Ь': '\'',
            'Ы': 'I\'',
            'Ъ': '',
            'Э': 'E\'',
            'Ю': 'Yu',
            'Я': 'Ya',
        },
        'retranslit': {
            'Sch': 'Щ',
            'sch': 'щ',
            'Yu': 'Ю',
            'Ya': 'Я',
            'yu': 'ю',
            'ya': 'я',
            'Ch': 'Ч',
            'ch': 'ч',
            'Sh': 'Ш',
            'sh': 'ш',
            'I\'': 'Ы',
            'i\'': 'ы',
            'e\'': 'э',
            'E\'': 'Э'
        }
    },
    'words': {
        'Ю ': '. ',
        'Б ': ', ',
        'Ь ': 'ь '
    },
};